import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconBitbucket({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M.519.8a.512.512 0 0 0-.512.596l2.176 13.208a.697.697 0 0 0 .682.584h10.439a.514.514 0 0 0 .512-.43L15.992 1.4a.512.512 0 0 0-.422-.586c-.029-.003-.058-.007-.09-.007L.52.8zm9.163 9.545H6.35l-.901-4.712h5.041l-.807 4.712z"/>
        </svg>
    );
}

export default IconBitbucket;
